import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Multitenant } from '../../../services/multitenant.provider';
import { StorageProvider } from '../../../services/storage.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { InfoPopupComponent } from '../infopopup/infopopup';
import { NavController, PopoverController } from '@ionic/angular';
import { UrlService } from 'src/app/services/url.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-detailheader',
  templateUrl: 'detailheader.html',
  styleUrls: ['detailheader.scss']
})
export class DetailHeaderComponent implements OnInit{
  @Input() title: string;
  @Input() id: number;
  @Input() type: string;
  @Input() slug: string;
  @Input() public favorited: boolean;
  @Input() public include: Array<string>;
  @Output() public notify: EventEmitter<string> = new EventEmitter();
  public logged: boolean;
  public unlogged: boolean;
  public profileName: string;
  public themeClass: string;
  public currentUrl = window.location.href;

  constructor(
    public navCtrl: NavController,
    private router: Router,
    private multiTenant: Multitenant,
    private popoverCtrl: PopoverController,
    public auth: AuthProvider,
    private storage: StorageProvider,
    private urlService: UrlService
  ) {
    const accessToken = storage.getStorage('access_token');
    if (accessToken) {
      this.logged = true;
      this.unlogged = false;
      this.profileName = storage.getStorage('logged_profile_name');
    } else {
      this.logged = false;
      this.unlogged = true;
    }
  }

  goToLogin() {
    this.router.navigate(['connexion']);
  }

  goToProfiles() {
    this.router.navigate(['profiles']);
  }

  ngOnInit() {
    this.themeClass = this.multiTenant.getDomainClass();
  }

  goBack() {
    this.urlService.previousUrl$.pipe(take(1)).subscribe({
      next: prevUrl => {
        if (prevUrl) {
          this.navCtrl.back();
        } else {
          this.router.navigate(['']);
        }
      }
    });
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'home' },
      cssClass: 'feature-tooltip'
    });
    (await popover).present(myEvent);
  }

  goToBoutique() {
    if (this.themeClass === 'lepq') {
      window.open( 'https://www.playbacpresse.fr/abonnements-le-petit-quotidien', '_blank' );
    } else if (this.themeClass === 'mquo') {
      window.open( 'https://www.playbacpresse.fr/abonnements-mon-quotidien', '_blank' );
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else if (this.themeClass === 'mquovideo') {
      window.open( 'https://www.playbacpresse.fr/abonnements-mon-quotidien-video' );
    } else if (this.themeClass === 'actuvideo') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu-video');
    } else if (this.themeClass === 'week') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-weekly', '_blank' );
    } else if (this.themeClass === 'mwne') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-weeklynews', '_blank' );
    } else if (this.themeClass === 'sema') {
      window.open( 'https://www.playbacpresse.fr/abonnements-mi-semanal', '_blank' );
    } else if (this.themeClass === 'woch') {
      window.open( 'https://www.playbacpresse.fr/abonnements-meine-woche', '_blank' );
    } else if (this.themeClass === 'mlwk') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-little-weekly', '_blank' );
    } else if (this.themeClass === 'mlne') {
      window.open( 'https://www.playbacpresse.fr/abonnements-my-little-weeklynews', '_blank' );
    } else if (this.themeClass === 'mwjp') {
      window.open( 'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank' );
    } else if (this.themeClass === 'mwde') {
      window.open( 'https://go.playbacpresse.fr/myweekly-german_2019.html', '_blank' );
    } else if (this.themeClass === 'mljp') {
      window.open( 'https://www.playbacpresse.fr/my-little-weekly-my-weekly-japonais', '_blank' );
    } else if (this.themeClass === 'mlde') {
      window.open( 'https://go.playbacpresse.fr/mylittleweekly-german_2019.html', '_blank' );
    } else {
      window.open('https://www.playbacpresse.fr', '_blank');
    }
  }

  showPopUp() {
    this.notify.emit('show');
  }
}
